import { defineStore } from 'pinia'

export default defineStore({
  id: 'auth',
  persist: true,
  state: () => {
    return {
      accessToken: '',
      refreshToken: '',
      expiresIn: 0,
      workspaceId: '',
      workspaceType: '', // VENDOR || IMPORT_AND_EXPORT
      companyType: '',
      cooperatorTypes: [] as string[] // PARTNER || CUSTOMER
    }
  },
  actions: {
    clear: function () {
      this.accessToken = ''
      this.refreshToken = ''
      this.workspaceId = ''
      this.companyType = ''
      this.expiresIn = 0
      this.cooperatorTypes = []
    },
    setWorkspace: function (payload: any) {
      const { id, companyType, type, cooperatorTypes } = payload || {}
      this.workspaceId = id
      this.companyType = companyType
      this.workspaceType = type
      this.cooperatorTypes = cooperatorTypes || []
    },
    setWorkspaceId: function (payload: any) {
      this.workspaceId = payload
    },
    setWorkspaceType: function (payload: any) {
      this.workspaceType = payload
    },
    setAccessToken: function (payload: any) {
      this.accessToken = payload
    },
    setRefreshToken: function (payload: any) {
      this.refreshToken = payload
    },
    setExpires: function (payload: any) {
      this.expiresIn = payload
    }
  },
  getters: {
    getWorkspace: function (payload: any) {
      return {
        id: this.workspaceId,
        companyType: this.companyType,
        type: this.type,
        cooperatorTypes: this.cooperatorTypes
      }
    }
  }
})
